/**
 * GENERATED FILE — DO NOT EDIT BY HAND.
 *
 * Source of truth: forest_models/forest_models/contracts/portfolio_identity_formats.json
 * Regenerate:      python3 scripts/check-portfolio-contracts.py --write
 * Enforced by:     scripts/ci-lint.sh (also the pre-push hook)
 *
 * These are the composite identity strings carried on the portfolio-ranking
 * wire. Django mints them, the FastAPI gateway re-mints them on its pending-offer
 * override, forest_models validates them and the strict client envelope parse
 * rejects the whole envelope when a served value differs by one byte, so editing
 * this file by hand re-creates exactly the hand-mirrored drift it exists to
 * prevent (ForestModeler-dfugh).
 *
 * Values are substituted VERBATIM here — no percent-encoding. Rendering one of
 * these with the route encoder changes served identities and turns the gate red.
 */

export const PORTFOLIO_IDENTITY_FORMAT_CONTRACT = 'portfolio-identity-formats.v1';

export type PortfolioIdentityFormat =
  | 'portfolio_job_id'
  | 'portfolio_record_id'
  | 'offer_decode_revision';

export const PORTFOLIO_IDENTITY_FORMAT_TEMPLATES: Readonly<
  Record<PortfolioIdentityFormat, string>
> = {
  portfolio_job_id: 'portfolio-job:{property_id}:{primary_job}:{signal_revision}',
  portfolio_record_id: 'portfolio-record-{property_id}',
  offer_decode_revision: 'offer-decode-job:{decode_job_id}',
};

export interface PortfolioIdentityFormatGoldenCase {
  readonly label: string;
  readonly property_id: string;
  readonly primary_job: string;
  readonly signal_revision: string;
  readonly decode_job_id: string;
  readonly formats: Readonly<Record<PortfolioIdentityFormat, string>>;
}

/** Cross-language golden cases: Python and TypeScript renderers must both reproduce these. */
export const PORTFOLIO_IDENTITY_FORMAT_GOLDEN: readonly PortfolioIdentityFormatGoldenCase[] = [
  {
    label: 'realistic Finnish realty id with a forest-access snapshot',
    property_id: '178-415-5-2',
    primary_job: 'scan',
    signal_revision: 'forest-access:2026-07-17T12:00:00+00:00',
    decode_job_id: 'decode-job-7',
    formats: {
      portfolio_job_id: 'portfolio-job:178-415-5-2:scan:forest-access:2026-07-17T12:00:00+00:00',
      portfolio_record_id: 'portfolio-record-178-415-5-2',
      offer_decode_revision: 'offer-decode-job:decode-job-7',
    },
  },
  {
    label: 'decode records nest the offer-decode revision inside the job id',
    property_id: '1-2-3-4',
    primary_job: 'decode',
    signal_revision: 'offer-decode-job:decode-job-7',
    decode_job_id: 'decode-job-7',
    formats: {
      portfolio_job_id: 'portfolio-job:1-2-3-4:decode:offer-decode-job:decode-job-7',
      portfolio_record_id: 'portfolio-record-1-2-3-4',
      offer_decode_revision: 'offer-decode-job:decode-job-7',
    },
  },
  {
    label: 'reserved and sub-delimiter characters survive byte for byte in both languages',
    property_id: 'a b/c&d=e?f#g+h%i',
    primary_job: 'open_plan',
    signal_revision: 'saved-plan:rev with space',
    decode_job_id: 'j!\'()*~k_l.m-n',
    formats: {
      portfolio_job_id: 'portfolio-job:a b/c&d=e?f#g+h%i:open_plan:saved-plan:rev with space',
      portfolio_record_id: 'portfolio-record-a b/c&d=e?f#g+h%i',
      offer_decode_revision: 'offer-decode-job:j!\'()*~k_l.m-n',
    },
  },
];
